import React from "react";
import styled from "styled-components";
import { ACTIVE_HEADER_VARIANT, HEADER_VARIANTS } from "../config/headerTheme";

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
`;

const HeaderTitle = styled.div`
  h6 {
    font-weight: 500;
    font-size: 16px;
    margin: 0;
    color: #000;
    text-align: left;
  }
`;

const HeaderBox = styled.div`
  --header-accent: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};

  border-radius: 15px;
  padding: 8px 15px;
  border: 1.5px solid var(--header-accent);
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    grid-template-columns: auto 1fr 1fr 1fr;
    gap: 8px;
  }
`;

const HeaderBoxItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: start;

  .label {
    color: #8D8E8E;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
  }

  .value {
    color: #8D8E8E;
    font-size: 14px;
    font-weight: 500;
    text-align: left;

    strong {
      color: #000;
      font-weight: 600;
    }

    .slash {
      font-weight: lighter;
      margin: 0 1px;
    }
  }
`;

const AvatarContainer = styled.div`
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 100%;
  margin-right: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    aspect-ratio: 1 / 1;
  }
`;

const RankingHeader = ({
    profile = null,
    localName = "-",
    localPosition = 0,
    localTotal = 0,
    latamPosition = 0,
    latamTotal = 0,
    level = "-",
    showLevel = true,
    headerContainer = null
}) => {
    return (
        <HeaderContainer ref={headerContainer}>
            <HeaderTitle>
                <h6>Tu ranking</h6>
            </HeaderTitle>

            <HeaderBox>
                <HeaderBoxItem>
                    <AvatarContainer>
                        <img src={profile} alt="avatar" />
                    </AvatarContainer>
                </HeaderBoxItem>

                <HeaderBoxItem>
                    <span className="label">{localName}</span>
                    <span className="value">
                        <strong>{localPosition}<span className="slash">/</span></strong>{localTotal}
                    </span>
                </HeaderBoxItem>

                <HeaderBoxItem>
                    <span className="label">Mundial</span>
                    <span className="value">
                        <strong>{latamPosition}<span className="slash">/</span></strong>{latamTotal}
                    </span>
                </HeaderBoxItem>

                {showLevel && (
                    <HeaderBoxItem>
                        <span className="label">Nivel</span>
                        <span className="value">
                            <strong>{level}</strong>
                        </span>
                    </HeaderBoxItem>
                )}
            </HeaderBox>
        </HeaderContainer>
    );
};

export default RankingHeader;
